import script from "./FirmInterprox.vue?vue&type=script&lang=ts&setup=true"
export * from "./FirmInterprox.vue?vue&type=script&lang=ts&setup=true"

import "./FirmInterprox.vue?vue&type=style&index=0&id=32a11a76&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32a11a76"]])

export default __exports__